import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import {
  comingSoon,
  deleteData,
  findGetParameter,
  isUsingWS,
  newPath,
  postData
} from "../../components/utilities/UtilityFunctions";
import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import StyledMenu from "../../components/layout/StyledMenu";
import SwapScorecardModal from "./components/SwapScorecardModal";

import * as Yup from "yup";
import { Formik } from "formik";

import {
  BCPScorecardForm,
  flatternFormSchema,
  getPlayerName
} from "../../components/utilities/FormUtilities";
import { globalVariables } from "../../global/GlobalVariables";
import {
  BCPCircleCheck,
  BCPGear,
  BCPLockKeyhole,
  BCPLockKeyholeOpen,
  BCPSignalStream,
  BCPTriangleExclamation,
  BCPXmark
} from "../../components/icons/bcp/BCPIcons";
import { isModalEmbed, isAppMode } from "../../global/AppOverlay";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { useConfirm } from "material-ui-confirm";
import StreamOptionsModal from "../stream/StreamOptionsModal";
import PromptIfDirty from "../../components/utilities/PromptIfDirty";
import { CatanTimer } from "../../components/icons/catan/CatanIcons";
import { useTranslation } from "react-i18next";

const embed = findGetParameter("embed") === "true";

export default function Pairing(props) {
  const {
    pairing,
    setPairing,
    jwt,
    authContext,
    scorecardId,
    modal,
    setRefreshPairings,
    setSwapTableModal,
    setP,
    preview,
    setModalOpen
  } = props;

  const [loading, setLoading] = useState(true);
  const [readOnly, setReadOnly] = useState(true);
  const [scorecard, setScorecard] = useState(null);
  const [scorecardSwitch, setScorecardSwitch] = useState(null);
  const [schema, setSchema] = useState({});

  const [modalPins, setModalPins] = useState(null);
  const [pins, setPins] = useState({});

  const [values, setValues] = useState({});
  const [isDone, setIsDone] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [valuesDirty, setValuesDirty] = useState(false);
  const [redirect, setRedirect] = useState(null);
  const [updating, setUpdating] = useState(false);

  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [streamAnchorEl, setStreamAnchorEl] = useState(null);

  const [timerUrl, setTimerUrl] = useState(null);

  const confirm = useConfirm();

  const appMode = isAppMode();
  const modalEmbed = isModalEmbed();
  const useWebSockets = isUsingWS(authContext);

  const { t } = useTranslation("translation", {
    keyPrefix: "misc.pairings"
  });

  const submitForm = async (
    newValues,
    newIsDone,
    checkPins,
    doubleLoss,
    newPins
  ) => {
    setUpdating(true);
    var body = {
      ...getInitialBody(pairing, scorecard),
      metaData: newValues || values,
      isDone: newIsDone,
      gameData: {
        metrics: []
      }
    };

    if (pairing.event?.passwordlessScoring || pairing.event?.isTO) {
      //
    } else if (
      (authContext?.authState?.identity?.userId &&
        pairing.activeUsers?.[authContext?.authState?.identity?.userId] &&
        !checkPins) ||
      (pairing?.jwt?.userId &&
        pairing.activeUsers?.[pairing?.jwt?.userId] &&
        !checkPins)
    ) {
      //
    } else if (!scorecard.requiresUnlock && !checkPins) {
    } else {
      for (
        let i = 1;
        i <= (pairing.gameSystem.tableSize ? pairing.gameSystem.tableSize : 2);
        i++
      ) {
        if (pairing[`player${i}`] || pairing.teamPairing?.[`teamPlayer${i}`]) {
          var currentPins = newPins || pins;
          let key =
            pairing.pairingType?.toLowerCase() === "teampairing"
              ? `teamPlayer${i}Pin`
              : `player${i}Pin`;
          body[key] = currentPins[`player${i}Pin`];
          if (!body[key] || body[key] === "") {
            postNotification(
              "error",
              `Please enter ${getPlayerName(
                pairing[`player${i}`],
                pairing.teamPairing?.[`teamPlayer${i}`]
                  ? `${pairing.teamPairing?.[`teamPlayer${i}`].name}'s Captain`
                  : "-------"
              )}'s pins`
            );
            setUpdating(false);
            return false;
          }
        }
      }
    }

    if (authContext?.authState?.identity?.userId)
      body.userId = authContext?.authState?.identity?.userId;
    if (pairing.updatedAt) body.lastUpdatedAt = pairing.updatedAt;

    if (jwt && jwt !== "") body.jwt = jwt;

    if (schema.bcpUpdateCols?.length > 0) {
      var metricDict = {};
      schema.bcpUpdateCols.forEach((bcpUpdateCol) => {
        var bcpfieldsarray = bcpUpdateCol.bcpfield.split(".");
        if (bcpfieldsarray.length === 2) {
          if (!metricDict[bcpfieldsarray[1]]) {
            metricDict[bcpfieldsarray[1]] = 1;
            body.gameData.metrics.push(bcpfieldsarray[1]);
          }
          if (!body.gameData[bcpfieldsarray[0]])
            body.gameData[bcpfieldsarray[0]] = {};

          body.gameData[bcpfieldsarray[0]][bcpfieldsarray[1]] =
            body.metaData[bcpUpdateCol.id] || 0;
        } else if (bcpfieldsarray.length === 3) {
          if (!metricDict[bcpfieldsarray[2]]) {
            metricDict[bcpfieldsarray[2]] = 1;
            body.gameData.metrics.push(bcpfieldsarray[2]);
          }
          if (!body.gameData[bcpfieldsarray[0]])
            body.gameData[bcpfieldsarray[0]] = {};

          body.gameData[bcpfieldsarray[0]][bcpfieldsarray[2]] =
            body.metaData[bcpUpdateCol.id] || 0;
        }
      });
    }

    if (doubleLoss) {
      Object.keys(body.metaData).forEach((key) => {
        if (
          body.metaData[key] !== "" &&
          (typeof body.metaData[key] === "number" ||
            !isNaN(Number(body.metaData[key])))
        ) {
          body.metaData[key] = "0";
        }
      });
      Object.keys(body.gameData).forEach((key) => {
        if (key !== "metrics") {
          Object.keys(body.gameData[key]).forEach((subKey) => {
            body.gameData[key][subKey] = "0";
          });
        }
      });
      setValues({ ...body.metaData });
    }

    try {
      if (pairing.pairingCollection === "BCPCasualPairing") {
        body.pairingType = "CasualPairing";
        await postData(`/pairings/${pairing.id}/submitScores`, {
          body: body
        });
      } else if (
        pairing.pairingType.toLowerCase() === "pairing" ||
        pairing.pairingType.toLowerCase() === "teampairing" ||
        pairing.pairingType.toLowerCase() === "seatedpairing"
      ) {
        if (!preview)
          await postData(`/pairings/${pairing.id}/submitScores`, {
            body: body
          });
      } else if (pairing.pairingTable === "BCPSeatedPairing") {
        comingSoon();
        return;
      } else {
        postNotification("error", t("notifications.errors.invalidPairingType"));
        return;
      }

      setValuesDirty(false);

      if (pairing.event?.isTO && isDone && !newIsDone)
        postNotification(
          "info",
          "This Scorecard has been altered and unsubmitted. When complete press Submit Score."
        );

      if (isDone !== newIsDone) setIsDone(newIsDone);
      if (newIsDone) {
        if (embed || props?.appRoute || modalEmbed) setIsSubmitted(true);
        else {
          setRedirect(
            pairing?.pairingCollection === "BCPCasualPairing"
              ? `${appMode ? "/app" : ""}/play/my-games`
              : pairing?.teamPairingId &&
                  !pairing?.event?.adepticonTeamEvent &&
                  !modal
                ? `${appMode ? "/app" : ""}/game/teamPairing/${
                    pairing.teamPairingId
                  }${jwt && jwt !== "" ? `?jwt=${jwt}` : ""}`
                : pairing?.event?.isTO
                  ? `${appMode ? "/app" : "/organize"}/event/${
                      pairing.event.id
                    }?active_tab=pairings${
                      pairing.event.currentRound
                        ? `&round=${pairing.event.currentRound}`
                        : ""
                    }`
                  : pairing?.event
                    ? `${appMode ? "/app" : ""}/event/${
                        pairing.event.id
                      }?active_tab=pairings${
                        pairing.event.currentRound
                          ? `&round=${pairing.event.currentRound}`
                          : ""
                      }`
                    : "/"
          );
          return true;
        }
      }
    } catch (err) {
      postNotification("error", err);
      setUpdating(false);
      return false;
    }
    setUpdating(false);
    if (setModalOpen) setModalOpen(false);
    return true;
  };

  // Creates results text for confirmation modal
  const createResultsText = () => {
    if (values) {
      const keys = Object.keys(values);
      const winners = [];
      let isDraw = false;

      // Gets all game winners and pushes them into winners array
      keys.forEach((key) => {
        if (key.includes(`-gameResult`)) {
          if (parseInt(values[key]) >= 2) {
            winners.push(values["lbl-player" + key.match(/\d+/)[0]]);
          }

          if (parseInt(values[key]) === 1) {
            isDraw = true;
            return;
          }
        }
      });

      if (isDraw) {
        return t("endedInADraw");
      }

      if (!winners.length) {
        return t("noWinner");
      }

      if (winners && winners.length === 1) {
        return t("playerIsTheWinner", { playerName: winners[0] });
      }

      if (winners && winners.length > 1) {
        let winnerString = "";
        winners.forEach((winner) => {
          winnerString += `${winner} ${t("and")} `;
        });

        winnerString.trim();

        return t("playersAreTheWinners", {
          playerNames: winnerString.slice(0, -5)
        });
      }
    }
  };

  const createCatanColors = (color) => {
    switch (color) {
      case "red":
      case 1:
        return "FF0000";

      case "blue":
      case 2:
        return "0000FF";

      case "orange":
      case 3:
        return "FFA500";

      case "white":
      case 4:
        return "FFFFFF";

      default:
        return "";
    }
  };

  const createTimerUrl = () => {
    const tableSize = values?.tableSize || 4;

    let timerUrl = `https://sharedgametimer.com/login?create=${`${pairing?.round}${pairing?.table}_${pairing?.eventId}`}&template=O3HTTycGUMi2BXGhtVQv`;

    for (let i = 1; i < tableSize + 1; i++) {
      timerUrl += `&pName=${
        (values?.[`p${i}-firstName`] || "Player") +
        "-" +
        (values?.[`p${i}-lastName`] || i.toString())
      }&pColor=${createCatanColors(i)}`;
    }

    setTimerUrl(timerUrl);
  };

  useEffect(() => {
    // Closes modal without redirect if websocket is being used
    if (useWebSockets && redirect && modal) {
      setP(null);
    } else if (redirect) {
      window.location.assign(redirect);
    }
    // eslint-disable-next-line
  }, [redirect]);

  // Catan timer setup
  useEffect(() => {
    if (scorecard?.useTimer) {
      createTimerUrl();
    }
    // eslint-disable-next-line
  }, [values]);

  useEffect(() => {
    const check = async () => {
      try {
        if (pairing.scorecard) {
          if (scorecardId) {
            if (
              pairing.scorecardUsedId &&
              pairing.scorecardUsedId !== scorecardId
            ) {
              setScorecardSwitch(pairing.scorecardUsedId);
              postNotification(
                "warning",
                pairing.isDone
                  ? t("gameSubmittedWithScorecard")
                  : t("gameStartedScoring")
              );
            } else if (
              pairing.scorecardId &&
              pairing.scorecardId !== scorecardId
            ) {
              setScorecardSwitch(pairing.scorecardId);
              postNotification("warning", t("viewingDifferentScorecard"));
            } else {
              setScorecardSwitch(null);
            }
          } else if (
            pairing.scorecardUsedId &&
            pairing.scorecardUsedId !== pairing.scorecard.id
          ) {
            setScorecardSwitch(pairing.scorecardUsedId);
            postNotification(
              "warning",
              pairing.isDone
                ? t("gameSubmittedWithScorecard")
                : t("gameStartedScoring")
            );
          } else {
            setScorecardSwitch(null);
          }

          setScorecard(pairing.scorecard);
          var formSchema = await flatternFormSchema(pairing.scorecard, pairing);

          setSchema(formSchema);
        } else {
          setScorecard(null);
        }

        setIsDone(pairing.isDone);
        setReadOnly(pairing.readOnly);
        setLoading(false);
      } catch (err) {
        postNotification("error", err);
      }
    };
    check();
    // eslint-disable-next-line
  }, []);

  const theme = useTheme();

  return (
    <>
      {pairing && (
        <Container sx={{ pt: modal ? 0 : 2, pb: modal ? 0 : 2 }} maxWidth="lg">
          <PromptIfDirty
            when={valuesDirty}
            message={t("unsavedChangesWarning")}
          />
          <Grid container sx={{ gap: 2 }}>
            <Grid
              item
              xs={12}
              sx={{
                p: 2
              }}
            >
              <Grid container>
                {!preview && (
                  <Grid
                    item
                    sx={{
                      width: "auto",
                      flex: 1
                    }}
                  >
                    <Typography variant="h4" gutterBottom>
                      {`${
                        pairing?.pairingType.toLowerCase() === "pairing"
                          ? `${t("pairing")} ${t("scorecard")}`
                          : pairing?.pairingType.toLowerCase() === "team"
                            ? `${t("team")} ${t("scorecard")}`
                            : pairing?.pairingType.toLowerCase() === "seated"
                              ? `${t("pairing")} ${t("scorecard")}`
                              : pairing?.pairingType.toLowerCase() === "casual"
                                ? `${t("casual")} ${t("scorecard")}`
                                : `${t("scorecard")}`
                      }${
                        pairing?.event?.name ? `: ${pairing?.event?.name}` : ""
                      }`}
                    </Typography>
                  </Grid>
                )}

                {!preview &&
                  pairing?.pairingType.toLowerCase() === "seatedpairing" &&
                  scorecard?.useTimer && (
                    <Grid item textAlign="right">
                      <IconButton
                        aria-label="timer"
                        href={timerUrl || "/"}
                        target="_blank"
                        disabled={!Boolean(timerUrl)}
                      >
                        <CatanTimer />
                      </IconButton>
                    </Grid>
                  )}
                {!preview &&
                  pairing?.pairingType.toLowerCase() === "seatedpairing" &&
                  (pairing?.event?.isTO ||
                    pairing?.event?.isStreamer ||
                    authContext?.authState?.identity?.isStreamer ||
                    authContext?.authState?.identity?.isAdmin ||
                    authContext?.authState?.identity?.adminGameSystems?.includes(
                      pairing?.event?.gameSystemId
                    )) && (
                    <Grid item textAlign="right">
                      <IconButton
                        aria-label="stream-overlay"
                        onClick={(e) => {
                          e.stopPropagation();
                          setStreamAnchorEl(e.currentTarget);
                        }}
                      >
                        <BCPSignalStream />
                      </IconButton>
                    </Grid>
                  )}

                {!modalEmbed &&
                  !preview &&
                  (pairing?.event?.isTO ||
                    authContext?.authState?.identity?.isAdmin ||
                    modal) && (
                    <Grid item textAlign="right">
                      <IconButton
                        aria-label="settings"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOptionsAnchorEl(e.currentTarget);
                        }}
                      >
                        <BCPGear />
                      </IconButton>
                    </Grid>
                  )}

                {((!embed && !props?.appRoute && !preview) ||
                  pairing?.teamPairingId) &&
                  pairing?.eventId &&
                  !modal &&
                  !modalEmbed && (
                    <Grid item textAlign="right" sx={{ width: "50px" }}>
                      <IconButton
                        aria-label="cancel"
                        color="error"
                        href={
                          pairing?.teamPairingId &&
                          !pairing?.event?.adepticonTeamEvent
                            ? `/game/teampairing/${pairing.teamPairingId}?${
                                embed || props?.appRoute ? "&embed=true" : ""
                              }${jwt ? `&jwt=${jwt}` : ""}`
                            : pairing.event?.isTO
                              ? `${appMode ? "/app" : "/organize"}/event/${
                                  pairing?.eventId
                                }?active_tab=pairings`
                              : `/event/${pairing?.eventId}?active_tab=pairings`
                        }
                      >
                        <BCPXmark />
                      </IconButton>
                    </Grid>
                  )}
              </Grid>
            </Grid>
            {Boolean(scorecardSwitch) && (
              <Grid
                item
                xs={12}
                sx={{
                  p: 2,
                  textAlign: "center"
                }}
              >
                <Button
                  href={newPath({
                    scorecardId: scorecardSwitch
                  })}
                  variant="contained"
                  color="warning"
                  startIcon={<BCPTriangleExclamation />}
                >
                  Switch Scorecards
                </Button>
              </Grid>
            )}
            <Grid
              item
              xs={12}
              sx={{
                p: 2
              }}
            >
              {!isSubmitted && schema?.rows && schema?.masterLists && (
                <>
                  <BCPScorecardForm
                    schema={schema}
                    record={pairing}
                    valuesDirty={valuesDirty}
                    setValuesDirty={setValuesDirty}
                    submitForm={submitForm}
                    readOnly={readOnly}
                    values={values}
                    setValues={setValues}
                    setUpdating={setUpdating}
                  />
                  {pairing?.showButtons && (
                    <Grid container spacing={1}>
                      {Boolean(
                        scorecard.requiresUnlock ||
                          scorecard.requiresUnlock === undefined
                      ) && (
                        <Grid item xs={12} sm>
                          <Button
                            fullWidth
                            variant="contained"
                            color="warning"
                            startIcon={
                              readOnly ? (
                                <BCPLockKeyhole outlined />
                              ) : (
                                <BCPLockKeyholeOpen outlined />
                              )
                            }
                            onClick={() => {
                              setModalPins("Enter Pins");
                            }}
                            disabled={!readOnly}
                          >
                            {readOnly ? "Unlock" : "Unlocked"}
                          </Button>
                        </Grid>
                      )}
                      {pairing?.event?.isTO &&
                        pairing?.pairingCollection !== "BCPCasualPairing" && (
                          <Grid item xs={12} sm>
                            <Button
                              fullWidth
                              variant="outlined"
                              color="error"
                              disabled={updating || readOnly}
                              onClick={async () => {
                                try {
                                  await confirm({
                                    title: `${t("confirm")} ${t("doubleLoss")}.`,
                                    description: t("areYouSureDoubleLoss"),
                                    dialogProps: {
                                      sx: {
                                        zIndex: 99999
                                      }
                                    }
                                  });
                                } catch (err) {
                                  return;
                                }

                                await submitForm(null, true, false, true);
                              }}
                            >
                              {t("doubleLoss")}
                            </Button>
                          </Grid>
                        )}
                      <Grid item xs={12} sm>
                        <Button
                          fullWidth
                          variant="contained"
                          color="success"
                          endIcon={
                            updating ? (
                              <CircularProgress
                                size={24}
                                sx={{
                                  color: "success.contrastText"
                                }}
                              />
                            ) : null
                          }
                          disabled={updating || readOnly}
                          onClick={async () => {
                            setModalPins("Submit Scores");
                          }}
                        >
                          {t("submitScores")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container spacing={3}>
                    <Grid item xs sx={{ mt: 1 }}>
                      <Typography variant="body1">
                        {t("pairingStatus")} :{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {preview
                            ? t("preview")
                            : isDone
                              ? t("submitted")
                              : t("unsubmitted")}
                        </span>
                      </Typography>
                    </Grid>
                  </Grid>
                  <PlayerPinsModal
                    record={pairing}
                    status={modalPins}
                    setStatus={setModalPins}
                    setReadOnly={setReadOnly}
                    setLoading={setLoading}
                    scorecard={scorecard}
                    setPins={setPins}
                    handlePostSubmit={submitForm}
                    createResultsText={createResultsText}
                    t={t}
                  />
                </>
              )}
              {isSubmitted && (
                <Grid container>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <BCPCircleCheck
                      color={theme?.palette?.success.main}
                      sx={{ fontSize: 200 }}
                    />
                  </Grid>
                  <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <Typography variant="h5">
                      {t("submittedMessage", {
                        siteTitle:
                          globalVariables().site?.title || "Best Coast Pairings"
                      })}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <OptionsMenu
            anchorEl={optionsAnchorEl}
            setAnchorEl={setOptionsAnchorEl}
            pairing={pairing}
            authContext={authContext}
            event={pairing?.event}
            setSwapTableModal={setSwapTableModal}
            setLoading={setLoading}
            setRefreshPairings={setRefreshPairings}
            setPairing={setPairing}
            modal={modal}
            setP={setP}
            t={t}
          />
          <StreamOptionsModal
            anchorEl={streamAnchorEl}
            setAnchorEl={setStreamAnchorEl}
            pairing={pairing}
            event={pairing?.event}
          />
        </Container>
      )}
      {loading && <ModalLoadingFull />}
    </>
  );
}

const getInitialBody = (record, scorecard) => {
  var body = {
    pairingType: record.pairingType || "Pairing"
  };

  if (body.pairingType.toLowerCase() === "pairing") {
    body.player1Id = record.player1Id;
    body.player2Id = record.player2Id;

    body.player1GameId = record.player1GameId;
    body.player2GameId = record.player2GameId;
  } else if (body.pairingType.toLowerCase() === "teampairing") {
    body.teamPlayer1Id = record.teamPlayer1Id;
    body.teamPlayer2Id = record.teamPlayer2Id;

    body.player1GameId = record.player1GameId;
    body.player2GameId = record.player2GameId;
  } else if (body.pairingType.toLowerCase() === "seatedpairing") {
    body.seatedPairingId = record.id;

    let playerNo = 0;
    for (let seatedPlayer of record.seatedPlayers) {
      playerNo++;
      body[`player${playerNo}Id`] = seatedPlayer.playerId;
    }
  } else if (body.pairingType.toLowerCase() === "casualpairing")
    body.casualPairingId = record.id;

  if (scorecard) {
    body.scorecardUsedId = scorecard.id;
    if (scorecard.type) body.scorecardType = scorecard.type;
  }
  return body;
};

function OptionsMenu(props) {
  const {
    anchorEl,
    setAnchorEl,
    authContext,
    event,
    pairing,
    setSwapTableModal,
    setLoading,
    setRefreshPairings,
    setPairing,
    modal,
    setP,
    t
  } = props;

  const open = Boolean(anchorEl);
  const confirm = useConfirm();
  const navigate = useNavigate();

  const [loading] = useState(false);
  const [sCMenuOpen, setSCMenuOpen] = useState(false);

  return (
    <>
      <StyledMenu
        id="options-menu"
        MenuListProps={{
          "aria-labelledby": "options-button"
        }}
        disableScrollLock
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        {modal && (
          <>
            <MenuItem
              disableRipple
              onClick={() => {
                navigate(
                  `/game/${
                    pairing?.pairingType
                      ? pairing.pairingType.toLowerCase()
                      : "pairing"
                  }/${pairing.id}`
                );
              }}
            >
              {t("expandScorecard")}
            </MenuItem>
            <Divider sx={{ mt: 1, mb: 1 }} />
          </>
        )}

        {(pairing?.event?.isTO ||
          authContext?.authState?.identity?.isAdmin) && (
          <>
            {modal && (
              <>
                {pairing?.pairingType?.toLowerCase() === "pairing" &&
                  Boolean(
                    event.scorecardId &&
                      event.gameSystem?.scorecardId &&
                      event.scorecardId !== event.gameSystem.scorecardId
                  ) && (
                    <MenuItem
                      component="a"
                      href={`/game/${
                        pairing?.pairingType
                          ? pairing.pairingType.toLowerCase()
                          : "pairing"
                      }/${pairing?.id}?useGSD=true`}
                      disableRipple
                    >
                      {getEnvironmentVariable("LABEL_GAMESYSTEM")}{" "}
                      {t("scorecard")}
                    </MenuItem>
                  )}
                <MenuItem
                  onClick={(e) => {
                    setSwapTableModal(true);
                    setAnchorEl(null);
                  }}
                  disableRipple
                >
                  {t("changeTable")}
                </MenuItem>
                <MenuItem
                  onClick={async (e) => {
                    try {
                      await confirm({
                        title: t("confirmClearScores"),
                        description: t("clearScoresConfirmation"),
                        dialogProps: {
                          sx: {
                            zIndex: 99999
                          }
                        }
                      });
                    } catch (err) {
                      return;
                    }
                    try {
                      setLoading(true);
                      await postData(`/pairings/${pairing.id}/clearScores`, {
                        body: {
                          pairingType: pairing?.pairingType || "Pairing"
                        }
                      });
                      setRefreshPairings(true);
                      postNotification("success", t("scoresCleared"));
                      setLoading(false);
                      setPairing(null);
                      setAnchorEl(null);
                      setP(null);
                    } catch (err) {
                      postNotification("error", err);
                      setLoading(false);
                    }
                  }}
                  disableRipple
                >
                  {t("clearScores")}
                </MenuItem>

                <MenuItem
                  onClick={async (e) => {
                    setLoading(true);

                    var metricDict = {
                      gameResult: "gameResult",
                      gamePoints: "gamePoints"
                    };
                    var body = {
                      isTO: true,
                      pairingType: pairing?.pairingType || "Pairing",
                      isDone: true,
                      metaData: {},
                      gameData: {
                        metrics: []
                      }
                    };
                    if (authContext?.authState?.identity?.userId) {
                      body.userId = authContext?.authState?.identity?.userId;
                    }
                    if (pairing?.metaData) {
                      Object.keys(pairing.metaData).forEach((key) => {
                        if (
                          pairing.metaData[key] !== "" &&
                          (typeof pairing.metaData[key] === "number" ||
                            !isNaN(Number(pairing.metaData[key])))
                        ) {
                          body.metaData[key] = "0";
                        } else {
                          body.metaData[key] = "";
                        }
                      });
                    }

                    var playerNo = 1;
                    if (pairing.seatedPlayers?.length) {
                      for (let seatedPlayer of pairing.seatedPlayers) {
                        let player = `player${playerNo}`;
                        body[`player${playerNo}Id`] = seatedPlayer.playerId;
                        body.gameData[player] = {
                          gameResult: 0,
                          gamePoints: 0
                        };
                        if (pairing.games?.[seatedPlayer.playerId]) {
                          for (let key of Object.keys(
                            pairing.games[seatedPlayer.playerId]
                          )) {
                            metricDict[key] = key;
                            body.gameData[player][key] = 0;
                          }
                        }
                        playerNo++;
                      }
                    } else {
                      while (pairing && pairing[`player${playerNo}`]) {
                        let player = `player${playerNo}`;
                        body.gameData[player] = {
                          gameResult: 0,
                          gamePoints: 0
                        };
                        if (pairing[player].game) {
                          for (let key of Object.keys(pairing[player].game)) {
                            metricDict[key] = key;
                            body.gameData[player][key] = 0;
                          }
                        }
                        playerNo++;
                      }
                    }

                    Object.keys(metricDict).forEach((key) => {
                      body.gameData.metrics.push(key);
                    });

                    try {
                      setLoading(true);
                      await postData(`/pairings/${pairing.id}/submitScores`, {
                        body: body
                      });
                      setAnchorEl(null);
                      setRefreshPairings(true);
                      postNotification(
                        "success",
                        t("notifications.success.pairingUpdated")
                      );
                      setLoading(false);
                      setPairing(null);
                      setP(null);
                    } catch (err) {
                      postNotification("error", err);
                      setLoading(false);
                    }
                  }}
                  disableRipple
                >
                  {pairing?.pairingType?.toLowerCase() === "teampairing"
                    ? "Give Both Teams Losses"
                    : pairing?.pairingType?.toLowerCase() === "seatedpairing"
                      ? "Give All Players Losses"
                      : "Give Both/All Players Losses"}
                </MenuItem>

                <MenuItem
                  onClick={async () => {
                    try {
                      await confirm({
                        title: `Confirm Delete Pairing.`,
                        description:
                          "Are you sure you want to delete this pairing?",
                        dialogProps: {
                          sx: {
                            zIndex: 99999
                          }
                        }
                      });
                    } catch (err) {
                      return;
                    }
                    try {
                      setLoading(true);
                      await deleteData(`/pairings/${pairing.id}`, {
                        body: {
                          pairingType: pairing?.pairingType || "Pairing"
                        }
                      });
                      setRefreshPairings(true);
                      postNotification("success", t("pairingDeleted"));
                      setLoading(false);
                      setPairing(null);
                      setAnchorEl(null);
                      setP(null);
                    } catch (err) {
                      postNotification("error", err);
                      setLoading(false);
                    }
                  }}
                  disableRipple
                >
                  {pairing?.pairingType?.toLowerCase() === "teampairing"
                    ? t("deleteTeamPairing")
                    : t("deletePairing")}
                </MenuItem>

                <Divider sx={{ mt: 1, mb: 1 }} />
              </>
            )}

            <MenuItem
              disableRipple
              onClick={() => {
                postNotification(
                  "warning",
                  t("notifications.warnings.comingSoon")
                );
              }}
            >
              Swap Scores
            </MenuItem>

            <MenuItem
              disableRipple
              onClick={(e) => {
                setSCMenuOpen(true);
              }}
            >
              {t("changeScorecard")}
            </MenuItem>
          </>
        )}
      </StyledMenu>
      {loading && <ModalLoadingFull />}

      <SwapScorecardModal
        sCMenuOpen={sCMenuOpen}
        setSCMenuOpen={setSCMenuOpen}
        pairing={pairing}
        authContext={authContext}
        event={event}
      />
    </>
  );
}

function PlayerPinsModal(props) {
  const {
    record,
    scorecard,
    status,
    setStatus,
    setReadOnly,
    setLoading,
    setPins,
    handlePostSubmit,
    createResultsText,
    t
  } = props;
  const [players, setPlayers] = useState([]);
  const [formParams, setFormParams] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        if (record) {
          var initialData = {};
          var validationSchema = {};
          var playerArray = [];

          if (record.event?.passwordlessScoring || record.event?.isTO) {
            //
          } else {
            for (
              let playerNo = 1;
              playerNo <=
              (record.gameSystem?.tableSize ? record.gameSystem.tableSize : 2);
              playerNo++
            ) {
              if (
                record[`player${playerNo}`] ||
                record.teamPairing?.[`teamPlayer${playerNo}`]
              ) {
                initialData[`player${playerNo}Pin`] = "";
                validationSchema[`player${playerNo}Pin`] =
                  Yup.string().required("Required");
                playerArray.push({
                  ...record.teamPairing?.[`teamPlayer${playerNo}`],
                  ...record[`player${playerNo}`],
                  player: `player${playerNo}`
                });
              }
            }
          }
          setFormParams({
            initialData: initialData,
            validationSchema: validationSchema
          });
          setPlayers(playerArray);
        }
      } catch (err) {
        postNotification("error", err);
      }
    };
    check();
  }, [record]);

  return (
    <Modal
      disableAutoFocus
      open={Boolean(status)}
      onClose={() => {
        setStatus(null);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
      sx={{ zIndex: Number.MAX_SAFE_INTEGER }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setStatus(null);
          }}
        >
          <BCPXmark />
        </IconButton>
        {formParams && (
          <Formik
            initialValues={formParams.initialData}
            validationSchema={Yup.object().shape(formParams.validationSchema)}
            onSubmit={async (values) => {
              setLoading(true);
              if (status === "Enter Pins") {
                var body = {
                  ...getInitialBody(record, scorecard),
                  ...values,
                  isDone: false
                };

                try {
                  await postData(`/pairings/${record.id}/submitScores`, {
                    body: body
                  });
                  setReadOnly(false);
                  setStatus(null);
                } catch (err) {
                  postNotification("error", err);
                }

                setPins(values);

                setLoading(false);
              } else {
                setPins(values);
                var ret = await handlePostSubmit(
                  null,
                  true,
                  true,
                  undefined,
                  values
                );
                if (ret) {
                  setReadOnly(true);
                  setLoading(false);
                  setStatus(null);
                } else {
                  setLoading(false);
                }
              }

              return;
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    pb: 1,
                    mb: 2,
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                  }}
                >
                  <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                      {status}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  container
                  xs={12}
                  spacing={1}
                  sx={{ textAlign: "center" }}
                >
                  <Grid item xs={12}>
                    <Typography variant="body1">
                      {createResultsText()}
                    </Typography>
                  </Grid>
                </Grid>

                {players &&
                  players.map((player, index) => {
                    var name = getPlayerName(
                      player,
                      player.teamCaptainId && player.name
                        ? `${player.name}'s Captain`
                        : "-------"
                    );
                    return (
                      <Grid key={index} container spacing={2}>
                        <Grid
                          item
                          xs={4}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}
                        >
                          <Typography variant="h5" gutterBottom>
                            {name}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <TextField
                            name={`${player.player}Pin`}
                            label={`${name} Pin`}
                            value={values[`${player.player}Pin`]}
                            variant="outlined"
                            fullWidth
                            required
                            margin="normal"
                            type="password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                        </Grid>
                      </Grid>
                    );
                  })}
                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: 1
                  }}
                >
                  <Grid item xs={6}>
                    <Button
                      color="error"
                      fullWidth
                      variant="outlined"
                      onClick={() => {
                        setStatus(null);
                      }}
                    >
                      {t("cancel")}
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      color="success"
                      fullWidth
                      variant="contained"
                      type="submit"
                    >
                      {status === "Enter Pins"
                        ? t("validatePins")
                        : t("confirm")}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        )}
      </Box>
    </Modal>
  );
}
